import { useState } from 'react'
import { getStore } from '@/utils/dva'
import { message as $message } from 'antd'
import { isLightChannel } from '@/utils/singleApp'

import { queryQuickOrderGuide, updateEndQuickOrderGuide } from '@/services/channel'

export default () => {
    const [experienceFastOrderGuideLoading, setExperienceFastOrderGuideLoading] = useState(true)
    const [experienceFastOrderGuideInfo, setExperienceFastOrderGuideInfo] = useState(null)

    // 检测是否需要拉取体验极速推单引导
    const checkCanExperienceFastOrderGuide = () => {
        let isCanExperienceFastOrderGuide = false
        try {
            const tagNames = getStore()?.getState()?.user?.currentUser?.tagNames
            const enableFindCooperationTag = `${tagNames}`?.includes('允许访问寻合作')
            const canExperienceFastOrder = isLightChannel || enableFindCooperationTag
            isCanExperienceFastOrderGuide = canExperienceFastOrder
        } catch (error) {
            console.error('检测是否需要拉取体验极速推单引导失败', error)
        }

        return isCanExperienceFastOrderGuide
    }

    // 获取极速推单引导步骤信息
    const loadExperienceFastOrderGuideInfo = async () => {
        if (!checkCanExperienceFastOrderGuide()) {
            return
        }
        setExperienceFastOrderGuideLoading(true)
        try {
            const { data, success, message } = await queryQuickOrderGuide({
                time: Date.now(),
            })

            if (!success) {
                $message.error(message)
            }

            setExperienceFastOrderGuideInfo(data)
            // setExperienceFastOrderGuideInfo({
            //     hasShelved: false,
            //     quickOrderGuideStatus: 'STARTING' // STARTING
            // })

            setExperienceFastOrderGuideLoading(false)
        } catch (error) {
            console.error('获取失败', error)
        }
    }

    // 更新结束极速推单引导
    const updateExperienceFastOrderGuideForEnd = async () => {
        const { success, message } = await updateEndQuickOrderGuide()
        if (!success) {
            $message.error(message)
        }

        setTimeout(() => {
            loadExperienceFastOrderGuideInfo()
        }, 100)
    }

    return {
        experienceFastOrderGuideLoading,
        experienceFastOrderGuideInfo,
        loadExperienceFastOrderGuideInfo,
        updateExperienceFastOrderGuideForEnd,
    }
}
